import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;
const reportUri = import.meta.env.REPORT_URI;

export default function useQuotation() {
  const createQuotation = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/quotations`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  const approveQuotation = async (_id) => {
    const result = await axios.post(
      `${apiUri}/api/v1/quotations/${_id}/approve`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const rejectQuotation = async (_id) => {
    const result = await axios.post(
      `${apiUri}/api/v1/quotations/${_id}/reject`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const queryQuotation = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (sort) reqBody.sort = sort;
    if (project) reqBody.project = project;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/quotations/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getQuotation = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/quotations/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  const createJournal = async (_id) => {
    const result = await axios.post(
      `${apiUri}/api/v1/quotations/${_id}/journal`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getPDF = async (template, data) => {
    const result = await axios.post(
      `${reportUri}/api/report`,
      {
        template: { name: template },
        data,
      },
      {
        responseType: "blob",
      }
    );
    return result;
  };

  const getQuotationCode = async () => {
    const result = await axios.get(`${apiUri}/api/v1/quotations/code`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  const patchQuotation = async (id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/quotations/${id}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data.data;
  };

  return {
    createQuotation,
    queryQuotation,
    getQuotation,
    approveQuotation,
    rejectQuotation,
    createJournal,
    getPDF,
    getQuotationCode,
    patchQuotation,
  };
}
